import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="Group 5438"
    xmlns="http://www.w3.org/2000/svg"
    width={71.656}
    height={54.355}
    {...props}>
    <path
      data-name="Path 27"
      d="M0 14.14h15.52L26.4 0H11.71z"
      transform="translate(45.253)"
      style={{
        fill: '#fff'
      }}
    />
    <path
      data-name="Path 28"
      d="M25.187 32.495H53.3v7.881H32.74a20.915 20.915 0 0 1-6.42-.931 15.659 15.659 0 0 1-5.076-2.645 11.632 11.632 0 0 1-3.327-4.1 11.879 11.879 0 0 1-1.186-5.323 11.63 11.63 0 0 1 1.221-5.325 13.153 13.153 0 0 1 3.372-4.174 15.228 15.228 0 0 1 5.085-2.767 19.785 19.785 0 0 1 6.33-.973h7.716L52.2 0H32.74a43.024 43.024 0 0 0-13.076 1.906A31.194 31.194 0 0 0 9.3 7.353 25.717 25.717 0 0 0 2.471 15.8 23.806 23.806 0 0 0 0 26.652a24.79 24.79 0 0 0 2.471 11.007A26.841 26.841 0 0 0 9.3 46.433a32.361 32.361 0 0 0 10.361 5.813 39.275 39.275 0 0 0 13.079 2.109h37.3V20.39H35.258z"
      style={{
        fill: '#fff'
      }}
    />
  </svg>
);

export default SvgComponent;
